import { render, staticRenderFns } from "./PlainSpec.vue?vue&type=template&id=435e6e25&scoped=true&"
import script from "./PlainSpec.vue?vue&type=script&lang=js&"
export * from "./PlainSpec.vue?vue&type=script&lang=js&"
import style0 from "./PlainSpec.vue?vue&type=style&index=0&id=435e6e25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435e6e25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('435e6e25', component.options)
    } else {
      api.reload('435e6e25', component.options)
    }
    module.hot.accept("./PlainSpec.vue?vue&type=template&id=435e6e25&scoped=true&", function () {
      api.rerender('435e6e25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PlainSpec.vue"
export default component.exports